"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARStatus = exports.default_op_state = exports.Language = exports.UnitsSystem = exports.formaInfoTimeStamp = exports.getInfoTimeStamp = exports.PickType = exports.StackQueueStatus = exports.SafetyStatus = exports.CALIB_TCP_INDEX = exports.PalletizerStatus = exports.Side = exports.RobotState = exports.InformationType = exports.IOLEVEL = exports.ControlType = void 0;
/*
 structs.ts
 various type, interface and enumeration defintions used in libapi
*/
var ControlType;
(function (ControlType) {
    ControlType[ControlType["Start"] = 0] = "Start";
    ControlType[ControlType["Stop"] = 1] = "Stop";
    ControlType[ControlType["Pause"] = 2] = "Pause";
    ControlType[ControlType["Home"] = 3] = "Home";
    ControlType[ControlType["Recover"] = 4] = "Recover";
    ControlType[ControlType["ManualMode"] = 5] = "ManualMode";
    ControlType[ControlType["GetPosition"] = 6] = "GetPosition";
    ControlType[ControlType["StartScanning"] = 7] = "StartScanning";
    ControlType[ControlType["OpenClampGripper"] = 8] = "OpenClampGripper";
    ControlType[ControlType["ExitManualMode"] = 9] = "ExitManualMode";
    ControlType[ControlType["TestPosition"] = 10] = "TestPosition";
})(ControlType = exports.ControlType || (exports.ControlType = {}));
var IOLEVEL;
(function (IOLEVEL) {
    IOLEVEL[IOLEVEL["GOOD"] = 0] = "GOOD";
    IOLEVEL[IOLEVEL["WARN"] = 1] = "WARN";
    IOLEVEL[IOLEVEL["BAD"] = 2] = "BAD";
    IOLEVEL[IOLEVEL["OFF"] = 3] = "OFF";
})(IOLEVEL = exports.IOLEVEL || (exports.IOLEVEL = {}));
var InformationType;
(function (InformationType) {
    InformationType["Status"] = "Status";
    InformationType["Error"] = "Error";
    InformationType["Warning"] = "Warning";
})(InformationType = exports.InformationType || (exports.InformationType = {}));
var RobotState;
(function (RobotState) {
    RobotState["Running"] = "Running";
    RobotState["Stopped"] = "Stopped";
    RobotState["Paused"] = "Paused";
    RobotState["Offline"] = "Offline";
    RobotState["Homing"] = "Homing";
})(RobotState = exports.RobotState || (exports.RobotState = {}));
var Side;
(function (Side) {
    Side[Side["Left"] = 0] = "Left";
    Side[Side["Right"] = 1] = "Right";
})(Side = exports.Side || (exports.Side = {}));
(function (IOLEVEL) {
})(IOLEVEL = exports.IOLEVEL || (exports.IOLEVEL = {}));
var PalletizerStatus;
(function (PalletizerStatus) {
    PalletizerStatus["Offline"] = "Offline";
    PalletizerStatus["Ready"] = "Ready";
    PalletizerStatus["Running"] = "Running"; /* or busy */
    PalletizerStatus["Homing"] = "Homing";
    PalletizerStatus["Fault"] = "Fault";
    PalletizerStatus["Scanning"] = "Scanning";
    PalletizerStatus["Freedrive"] = "Freedrive";
    PalletizerStatus["Testing"] = "Testing";
})(PalletizerStatus = exports.PalletizerStatus || (exports.PalletizerStatus = {}));
var CALIB_TCP_INDEX;
(function (CALIB_TCP_INDEX) {
    CALIB_TCP_INDEX[CALIB_TCP_INDEX["SlipSheet"] = 0] = "SlipSheet";
    CALIB_TCP_INDEX[CALIB_TCP_INDEX["Box"] = 1] = "Box";
})(CALIB_TCP_INDEX = exports.CALIB_TCP_INDEX || (exports.CALIB_TCP_INDEX = {}));
var SafetyStatus;
(function (SafetyStatus) {
    SafetyStatus[SafetyStatus["Triggered"] = 0] = "Triggered"; /* Estop */
    SafetyStatus[SafetyStatus["Resetting"] = 1] = "Resetting";
    SafetyStatus[SafetyStatus["Ready"] = 2] = "Ready";
    SafetyStatus[SafetyStatus["Offline"] = 3] = "Offline";
})(SafetyStatus = exports.SafetyStatus || (exports.SafetyStatus = {}));
var StackQueueStatus;
(function (StackQueueStatus) {
    StackQueueStatus[StackQueueStatus["Waiting"] = 0] = "Waiting"; /* Blue Dot */
    StackQueueStatus[StackQueueStatus["Running"] = 1] = "Running"; /* Green Dot */
    StackQueueStatus[StackQueueStatus["Complete"] = 2] = "Complete"; /* Gray Dot (TODO: Checkmark) */
})(StackQueueStatus = exports.StackQueueStatus || (exports.StackQueueStatus = {}));
var PickType;
(function (PickType) {
    PickType[PickType["Box"] = 0] = "Box";
    PickType[PickType["SlipSheet"] = 1] = "SlipSheet";
    PickType[PickType["TopSlipSheet"] = 2] = "TopSlipSheet";
})(PickType = exports.PickType || (exports.PickType = {}));
function getInfoTimeStamp(start, last_log, now) {
    return {
        delta_log: now.getTime() - last_log.getTime(),
        delta_start: now.getTime() - start.getTime(),
    };
}
exports.getInfoTimeStamp = getInfoTimeStamp;
function addZeroPrefix(n) {
    if (n < 10)
        return `0${n}`;
    return `${n}`;
}
function toDateString(seconds) {
    let h, m, s;
    h = Math.floor(seconds / (60 * 60 * 1000));
    seconds -= h * 60 * 60 * 1000;
    m = Math.floor(seconds / (60 * 1000));
    seconds -= m * 60 * 1000;
    s = seconds / 1000;
    return `${addZeroPrefix(h)}:${addZeroPrefix(m)}:${addZeroPrefix(s)}`;
}
function formaInfoTimeStamp(ts) {
    return [`+${ts.delta_log / 1000}s`, toDateString(ts.delta_start)];
}
exports.formaInfoTimeStamp = formaInfoTimeStamp;
var UnitsSystem;
(function (UnitsSystem) {
    UnitsSystem["METRIC"] = "Metric";
    UnitsSystem["IMPERIAL"] = "Imperial";
})(UnitsSystem = exports.UnitsSystem || (exports.UnitsSystem = {}));
var Language;
(function (Language) {
    Language["ENGLISH"] = "English";
    Language["GERMAN"] = "German";
    Language["SPANISH"] = "Spanish";
    Language["FRENCH"] = "French";
})(Language = exports.Language || (exports.Language = {}));
function default_op_state() {
    return {
        status: PalletizerStatus.Offline,
        auxiliary_text: '...',
    };
}
exports.default_op_state = default_op_state;
var ARStatus;
(function (ARStatus) {
    ARStatus[ARStatus["LOCKED"] = 0] = "LOCKED";
    ARStatus[ARStatus["UNLOCKED"] = 1] = "UNLOCKED";
})(ARStatus = exports.ARStatus || (exports.ARStatus = {}));
